import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useState, useEffect } from "react";

import { toast } from "react-toastify";

import {
  getThemeURL,
  geteventdetails,
  deleteevent,
} from "../../../Services/EndPoints";

import Moment from "react-moment";
// import {
//   masterResourceTableData,
// } from "../../../JsonData/MasterResourceConfig";

import Loader from "react-spinner-loader";
import { useTranslation } from "react-i18next";
import Confirmpopup from "../Common/ConfirmPopup/Confirmpopup";
import { getExportedColumnsData } from "../../../Components/UiComponents/utils";
import { Deleteicon } from "../../../Components/IconComponents";

import {
  getData,
  postDataWithBody,
} from "../../../Services/Services";
import { setTableData } from "../../../CentralStore/ExportLMSTable/dataSlice";
import EventShowTable from "../../../Components/UiComponents/Table/EventShowTable";
import { evetnresourcecolumnsForExport } from "../../../JsonData/EventResourceConfig";
import { RoleContext } from "../../..";

const EventTable = ({ selectedIncidentId, onEventDeleted }) => {
  const { roleName } = useContext(RoleContext);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(false);
  // const qs = require("qs");
  // const [masterResourceData, setMasterResourceData] = useState(
  //   masterResourceTableData
  // );
  const [searchData, setSearchData] = useState([]);
  const [rowCount, setRowCount] = useState(0);

  const { t } = useTranslation();

  useEffect(() => {
    if (selectedIncidentId) {
      // Fetch events related to this incident
      getMasterResourceList(selectedIncidentId);
      console.log("Fetching events for incident:", selectedIncidentId);
      // Add your API call here using the selectedIncidentId
    }
  }, [selectedIncidentId]);

  useEffect(() => {
    sendDataToCentralStore(searchData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchData]);

  async function getMasterResourceList(id) {
    setLoader(true);

    let masterResourceList = await postDataWithBody(geteventdetails, [id], {});

    let sortedList = masterResourceList.sort((a, b) => {
      return new Date(b.created_on) - new Date(a.created_on);
    });
    // Add sequence number to each event
    const enrichedList = sortedList.map((item, index) => ({
      ...item,
      sequenceNo: index + 1,
      eventTime: item.eventTime || null,
    }));
    setLoader(false);

    setRowCount(enrichedList.length);
    setData(enrichedList);
  }
  const sendDataToCentralStore = (data) => {
    if (data.length > 0) {
      const columns = evetnresourcecolumnsForExport;
      dispatch(
        setTableData({
          columns,
          tableData: getExportedColumnsData(columns, data),
        })
      );
    }
  };
  const addNewHandler = () => {
    navigate("/situation-awareness/create-event");
  };
  const handleDownload = () => {
    if (!data || data.length === 0) {
      toast.warning("No data to download");
      return;
    }

    // Filter out the "Action" column (accessor: "action")
    const filteredColumns = columns.filter((col) => col.Header !== "Actions");

    // Prepare headers for CSV
    const headers = filteredColumns.map((col) => ({
      key: col.accessor,
      header: col.Header,
    }));

    // Convert data to CSV (excluding "Action" column)
    const csvContent = convertToCSV(data, headers);

    // Create download link
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute(
      "download",
      `event_data_${new Date().toISOString().slice(0, 10)}.csv`
    );
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const convertToCSV = (data, headers) => {
    // Header row
    const headerRow = headers.map((h) => `"${h.header}"`).join(",");

    let csv = headerRow + "\n";

    // Data rows
    data.forEach((row) => {
      const values = headers.map((header) => {
        const value = row[header.key];

        // Format date if column is "eventTime"
        if (header.key === "eventTime" && value) {
          return `"${new Date(value).toLocaleString()}"`;
        }

        // Escape quotes and handle null/undefined
        return `"${(value || "").toString().replace(/"/g, '""')}"`;
      });
      csv += values.join(",") + "\n";
    });

    return csv;
  };

  const columns = React.useMemo(
    () => [
      {
        Header: t("S.No."), // Changed from "Event ID" to "Sr. No."
        accessor: "sequenceNo", // Changed from "id" to "sequenceNo"
        Cell: (props) => {
          return props.value || props.row.index + 1;
        },
        disableSortBy: true,
      },
      {
        Header: t("Incident Name"),
        accessor: "incidentName",
        Cell: (props) => {
          if (props.value) {
            let categoryText = props.value;
            if (props.value.length > 15) {
              categoryText = props.value.substring(0, 15) + "...";
            }
            return <span title={props.value}>{categoryText}</span>;
          } else {
            return "NA";
          }
        },
        disableSortBy: true,
      },
      {
        Header: t("Event Date & Time"),
        accessor: "eventTime",
        Cell: (props) => {
          if (props.value) {
            return <Moment format="DD/MM/YYYY, HH:mm ">{props.value}</Moment>;
          } else {
            return "NA";
          }
        },
        disableSortBy: true,
        leftAlign: true,
      },
      {
        Header: t(" Event Created By"),
        accessor: "createdBy",
        disableSortBy: true,
        leftAlign: true,
      },

      {
        Header: t(" Event Description"),
        accessor: "action",
        Cell: (props) => {
          if (props.value) {
            let des = props.value;
            if (props.value.length > 15) {
              des = props.value.substring(0, 15) + "...";
            }
            return <span title={props.value}>{des}</span>;
          } else {
            return "NA";
          }
        },

        disableSortBy: true,
        leftAlign: true,
      },

      {
        Header: t("masterresourcetableheaders.action"),
        disableSortBy: true,

        Cell: (props) => {
          const [isdelete, setIsdelete] = useState(false);
          const [selectedId, setSelectedId] = useState(null);
          // eslint-disable-next-line no-unused-vars
          const [selectedName, setSelectedName] = useState(null);
          const [username, setusername] = useState("");
          const getUserdataprof = async () => {
            try {
              const usr_prof = await getData(getThemeURL);
              setusername(usr_prof[0].user_name);
            } catch (error) {}
          };
          const deletePopUp = (id, resource_image_name) => {
            getUserdataprof();
            setSelectedId(id);
            setSelectedName(resource_image_name);
            setIsdelete(!isdelete);
          };
          const deleteTableDataById = async () => {
            try {
              const req = {
                eventId: selectedId,
                userId: username,
              };
              const response = await postDataWithBody(deleteevent, req, {});
              if (
                response?.message ===
                "Event and related images deleted successfully."
              ) {
                await getMasterResourceList(selectedIncidentId);
                if (onEventDeleted) {
                  onEventDeleted();
                }
                toast.success(response.message || t("delete_success_message"), {
                  position: toast.POSITION.TOP_CENTER,
                  autoClose: 2000,
                });
              }
            } catch (error) {
              toast.error(t("delete_error_message"), {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
              });
              console.error("Delete error:", error);
            } finally {
              setIsdelete(false);
              setSelectedId(null);
            }
          };

          const handleDelete = () => {
            // getUserdataprof()
            deleteTableDataById();
            //deleteTableDataImageByName();
          };

          return (
            <div className="usertable__actionsicon">
              {roleName !== process.env.REACT_APP_SUPER_ADMIN ? (
                <Deleteicon
                  value={props.value}
                  className="mr-1"
                  style={{ opacity: 0.5, cursor: "not-allowed" }}
                  title="Super Admin cannot delete"
                />
              ) : (
                <span
                  onClick={() =>
                    deletePopUp(
                      props.row.original.id,
                      props.row.original.resource_image_name
                    )
                  }
                >
                  <Deleteicon
                    value={props.value}
                    className="cursor-pointer mr-1"
                  />
                </span>
              )}

              {isdelete && (
                <Confirmpopup
                  show={isdelete}
                  title={t("deletepopuptext")}
                  message={t("deletepopupmessage")}
                  handleToggle={deletePopUp}
                  row={props.row}
                  name={props.row.original.activity}
                  deleteRow={handleDelete}
                  cancel={t("cancelbutton")}
                  action={t("actionbutton")}
                />
              )}
            </div>
          );
        },
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [t, selectedIncidentId]
  );
  return (
    <div className="create-user">
      <Loader
        show={loader}
        type="body"
        stack="vertical"
        message="Loading Data"
      />
      <div className="datatable__container">
        {data && (
          <EventShowTable
            data={data}
            addButtonLabel={t("Create Event")}
            addNewHandler={addNewHandler}
            setSearchData={setSearchData}
            columns={columns}
            numberOfRows={10}
            rowCount={rowCount}
            showExport={false}
            showFilter={false}
            showReset={false}
            onExpand={false}
            onDownload={handleDownload}
            headerTableHeadStyle={{ background: "#18a3a0", color: "#FFFFFF" }}
            tableStyle={{
              border: "1px solid  #f0f0f0",
              borderRadius: "12px",
            }}
          />
        )}
      </div>
    </div>
  );
};

export default EventTable;